(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elune-footer-newsletter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elune-newsletter-feedback')) {
    customElements.define('elune-newsletter-feedback', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const success = this.querySelector('.ef-newsletter-success');
        if (success) {
          success.scrollIntoView({ block: 'center', behavior: 'instant' });
          success.focus({ preventScroll: true });
          return;
        }
        const form = this.querySelector('form');
        const status = this.querySelector('.ef-newsletter-status');
        if (!form || !status) return;

        // Observe native submission without taking over Shopify's CAPTCHA or POST.
        this.addEventListener('submit', () => {
          clearTimeout(this.waitTimer);
          status.textContent = this.dataset.pendingMessage;
          status.hidden = false;
          this.waitTimer = setTimeout(() => {
            // A delay is not proof of either subscription success or failure.
            status.textContent = this.dataset.delayedMessage;
          }, 15000);
        }, { capture: true, signal: this.controller.signal });

        form.addEventListener('input', () => {
          clearTimeout(this.waitTimer);
          status.hidden = true;
          status.textContent = '';
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.waitTimer);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["elune-product-ui"] && !Shopify.designMode) return;
  try {
    (() => {
 const init=()=>document.querySelectorAll('[data-voice-playback]').forEach(area=>{
  if(area.dataset.ready)return;
  const form=area.closest('form');
  let variants;try{variants=JSON.parse(area.querySelector('[data-playback-variants]').textContent);}catch{return;}
  const sizes=[...form.querySelectorAll('input[name="id"]')];
  if(!sizes.length||!sizes.every(r=>variants.some(v=>v.size===r.dataset.playbackSize&&v.playback==='Artwork Only')&&variants.some(v=>v.size===r.dataset.playbackSize&&v.playback==='With Voice Playback')))return;
  area.dataset.ready='true';area.hidden=false;area.disabled=false;form.querySelector('[data-playback-fallback]').hidden=true;
  const sync=()=>{const option=area.querySelector('input:checked').value;
   for(const radio of sizes){const v=variants.find(v=>v.size===radio.dataset.playbackSize&&v.playback===option);radio.value=v.id;radio.dataset.cents=String(v.price);radio.dataset.money=v.money;radio.dataset.title=v.title;radio.disabled=!v.available;radio.closest('label').querySelector('.choice-price').textContent=v.money;}
  };
  form.addEventListener('change',sync,true);sync();
  sizes.find(r=>r.checked)?.dispatchEvent(new Event('change',{bubbles:true}));
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
(() => {
  const init = () => {
    document.querySelectorAll('.elune-order-form').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const status = form.querySelector('[data-order-status]');
      const button = form.querySelector('[data-add-button]');
      const buyNowButton = form.querySelector('[data-buy-now-button]');
      const actionButtons = [button, buyNowButton].filter(Boolean);
      const addon = form.querySelector('[data-addon-select]');
      const addonArea = form.querySelector('[data-addon-area]');
      if (addonArea) addonArea.hidden = false;
      let imageUrl, audioUrl, mainAdded = false;
      const files = Array.from(form.querySelectorAll('input[type=file]'));
      files.forEach(input => input.addEventListener('change', () => {
        input.setCustomValidity('');
        const file = input.files?.[0];
        const tooLarge = Boolean(file && file.size > 10 * 1024 * 1024);
        if (tooLarge) input.setCustomValidity('Please choose a file smaller than 10 MB.');
        const upload = input.closest('[data-elune-upload]');
        const photo = input.hasAttribute('data-photo-input');
        const wrongPhotoType = Boolean(file && photo && upload?.dataset.fileTypeError && (!/\.(jpe?g|png|webp)$/i.test(file.name) || (file.type && !['image/jpeg', 'image/jpg', 'image/png', 'image/webp'].includes(file.type))));
        if (wrongPhotoType && !tooLarge) input.setCustomValidity(upload.dataset.fileTypeError);
        if (upload) {
          const emptyState = upload.querySelector('[data-upload-empty]');
          const selectedState = upload.querySelector('[data-upload-selected]');
          const filename = upload.querySelector('[data-upload-filename]');
          const uploadStatus = upload.querySelector('[data-upload-status]');
          if (emptyState) emptyState.hidden = Boolean(file);
          if (selectedState) selectedState.hidden = !file;
          if (filename) filename.textContent = file ? file.name : '';
          if (uploadStatus) uploadStatus.textContent = tooLarge ? 'This file is over 10 MB. Choose a smaller file.' : wrongPhotoType ? upload.dataset.fileTypeError : 'Selected · click to replace';
          upload.classList.toggle('has-file', Boolean(file));
          upload.classList.toggle('has-error', tooLarge || wrongPhotoType);
        }
        const preview = form.querySelector(photo ? '[data-photo-preview]' : '[data-audio-preview]');
        if (preview) {
          if (photo && imageUrl) URL.revokeObjectURL(imageUrl);
          if (!photo && audioUrl) URL.revokeObjectURL(audioUrl);
          preview.hidden = !file || tooLarge || wrongPhotoType;
          if (!preview.hidden) {
            const url = URL.createObjectURL(file);
            if (photo) imageUrl = url; else audioUrl = url;
            preview.src = url;
          }
        }
        if (!input.validity.valid) input.reportValidity();
      }));
      form.querySelectorAll('[data-upload-drop]').forEach(zone => {
        if (zone.dataset.dropReady) return;
        zone.dataset.dropReady = 'true';
        zone.addEventListener('dragenter', event => { event.preventDefault(); zone.classList.add('is-dragging'); });
        zone.addEventListener('dragover', event => { event.preventDefault(); if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy'; zone.classList.add('is-dragging'); });
        zone.addEventListener('dragleave', event => { if (!zone.contains(event.relatedTarget)) zone.classList.remove('is-dragging'); });
        zone.addEventListener('drop', event => {
          event.preventDefault();
          zone.classList.remove('is-dragging');
          const input = zone.querySelector('input[type="file"]');
          const file = event.dataTransfer?.files?.[0];
          if (!input || !file) return;
          try {
            const transfer = new DataTransfer();
            transfer.items.add(file);
            input.files = transfer.files;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          } catch {
            input.focus();
          }
        });
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const buyNow = event.submitter === buyNowButton;
        if (mainAdded || actionButtons.some(action => action.disabled) || !form.reportValidity()) return;
        actionButtons.forEach(action => { action.disabled = true; });
        status.textContent = 'Uploading your customization. Please keep this page open…';
        const endpoint = form.action.replace(/\/cart\/add(?:\?.*)?$/, '/cart/add.js');
        const bagUrl = form.action.replace(/\/cart\/add(?:\?.*)?$/, '/cart');
        const checkoutUrl = form.action.replace(/\/cart\/add(?:\?.*)?$/, '/checkout');
        const body = new FormData(form);
        const group = crypto.randomUUID();
        body.set('properties[_ELUNE group]', group);
        for (const [key,value] of [...body.entries()]) if (value instanceof File && value.size === 0) body.delete(key);
        try {
          const response = await fetch(endpoint, {method:'POST',body,headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'We could not add this item. Please check your files and try again.');
          mainAdded = true;
          const item = result.items?.[0] || result;
          if (addon?.checked) {
            status.textContent = 'Your artwork is in the bag. Adding the matching mini…';
            const properties = {'_ELUNE group':group,'Matching artwork':item.product_title || item.title || 'Main artwork','Photo':item.properties?.Photo || 'Use the photo on the matching artwork in this order','Art style':String(body.get('properties[Matching mini style]') || 'Signature Portrait'),'Figure height':'Approximately 100 mm'};
            const miniResponse = await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:51784883372338,quantity:1,properties}]})});
            if (!miniResponse.ok) throw new Error('Your artwork was added, but the matching mini could not be added. Please review your bag before trying again.');
          }
          status.textContent = buyNow ? 'Taking you to checkout…' : 'Added to your bag.';
          if (buyNow) { location.assign(checkoutUrl); return; }
          if (window.EluneBagDrawer) {
            await window.EluneBagDrawer.open();
            mainAdded = false;
            actionButtons.forEach(action => { action.disabled = false; });
          } else location.assign(bagUrl);
        } catch(error) {
          status.textContent = error.message || 'Something went wrong. Please try again.';
          if (mainAdded) {
            const link = document.createElement('a');link.href=bagUrl;link.textContent=' View your bag';status.append(link);
            actionButtons.forEach(action => { action.textContent = 'Artwork already added'; });
          } else actionButtons.forEach(action => { action.disabled = false; });
        }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load',init);
})();


(() => {
 if(window.eluneSizeStyleReady)return;
 window.eluneSizeStyleReady=true;
 const sync=form=>{
  const variant=form.querySelector('input[name="id"]:checked') || form.querySelector('select[name="id"] option:checked');
  const price=document.querySelector('[data-current-price]');
  if(variant?.dataset.money && price)price.textContent=variant.dataset.money;
  const style=form.querySelector('input[name="properties[Art style]"]:checked');
  const summary=form.querySelector('[data-style-summary]');
  if(summary && style)summary.textContent=style.value;
  const addon=form.querySelector('[data-addon-select]');
  const mini=form.querySelector('[data-mini-style]');
  if(mini)mini.disabled=!addon?.checked;
 };
 const init=()=>document.querySelectorAll('.elune-order-form').forEach(sync);
 document.addEventListener('change',event=>{const form=event.target.closest('.elune-order-form');if(form)sync(form)});
 document.addEventListener('shopify:section:load',init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

(() => {
 const init=()=>document.querySelectorAll('.elune-order-form').forEach(form=>{
  if(form.dataset.wizardReady)return;
  const panels=[...form.querySelectorAll('[data-custom-step]')];if(panels.length!==3)return;
  form.dataset.wizardReady='true';
  const figureInline=!!form.querySelector('[data-mini-variant-select]');form.noValidate=!figureInline;
  let active=0,started=false;
  const nav=[...form.querySelectorAll('[data-step-go]')];
  const sticky=document.querySelector('[data-mobile-purchase]');
  const preview=document.querySelector('[data-customization-preview]');
  const money=c=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(c/100);
  const updatePreview=()=>{
   if(!preview)return;
   const photo=form.querySelector('[data-photo-input]')?.files?.[0];
   const audio=form.querySelector('[data-audio-input]')?.files?.[0];
   const stage=active===2?'Ready to review':active===1?'Add your files':'Choose your format';
   const title=active===2?'Your customization is ready to review':photo||audio?'Your story is taking shape':'Shape your story';
    const copy=active===2?'Review your selections before adding to your bag or going straight to checkout.':photo||audio?'Your files are attached to this order. Add anything else that will help us understand the moment.':'Choose a size and color, then add your photo and real voice.';
   preview.querySelector('[data-preview-step]').textContent=`${active+1} / 3 · ${stage}`;
   preview.querySelector('[data-preview-title]').textContent=title;
   preview.querySelector('[data-preview-copy]').textContent=copy;
   preview.querySelector('[data-preview-photo-status]').textContent=photo?.name||'Waiting for upload';
   preview.querySelector('[data-preview-audio-status]').textContent=audio?.name||'Waiting for upload';
  };
  const sync=()=>{
   const variant=form.querySelector('input[name="id"]:checked')||form.querySelector('select[name="id"] option:checked');
   const cents=Number(variant?.dataset.cents||variant?.dataset.price||0);
   const qty=Math.max(1,Number(form.querySelector('[name="quantity"]')?.value)||1);
   const addon=form.querySelector('[data-addon-select]')?.checked;
   const mini=form.querySelector('[data-mini-style]');if(mini)mini.disabled=!addon;
   const rows=[];
   if(variant)rows.push(['Size / format',variant.dataset.title||variant.textContent.trim()]);
   for(const input of form.querySelectorAll('[name^="properties["]')){
    if(input.disabled||((input.type==='radio'||input.type==='checkbox')&&!input.checked))continue;
    const value=input.type==='file'?[...input.files].map(f=>f.name).join(', '):input.value;
    if(value)rows.push([input.name.slice(11,-1),value]);
   }
   rows.push(['Quantity',String(qty)],['Matching mini',addon?'1 × '+money(2999)+' with this artwork':'Not added']);
   const summary=form.querySelector('[data-review-items]');summary.replaceChildren();
   for(const [key,value]of rows){const row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');row.dataset.reviewKey=key;dt.textContent=key;dd.textContent=value;
    if(form.querySelector('.elune-review')){
     const icons={'Color':'M12 3C9 7 5 10 5 14a7 7 0 0 0 14 0c0-4-4-7-7-11z',
      'Size / format':'M5 3h4m6 0h4v4m0 10v4h-4m-6 0H5v-4M5 7v6M19 11v2','Voice Playback':'M3 9h4l5-5v16l-5-5H3zM16 8a6 6 0 0 1 0 8M19 5a10 10 0 0 1 0 14','Photo':'M3 3h18v18H3zM3 16l5-5 5 5 4-4 4 4M8 7h.01','Audio':'M9 18V5l11-2v13M9 8l11-2M9 18c0 3-6 4-6 1s6-4 6-1M20 16c0 3-6 4-6 1s6-4 6-1'};
     const label=document.createElement('span');label.textContent=key;dt.replaceChildren(label);
     if(icons[key]){const icon=document.createElementNS('http://www.w3.org/2000/svg','svg');icon.setAttribute('viewBox','0 0 24 24');icon.setAttribute('aria-hidden','true');const path=document.createElementNS('http://www.w3.org/2000/svg','path');path.setAttribute('d',icons[key]);icon.append(path);dt.prepend(icon);}
    }
    row.append(dt,dd);summary.append(row);}
   form.querySelector('[data-review-total]').textContent=money(cents*qty+(addon?2999:0));
    document.querySelectorAll('[data-sticky-price]').forEach(el=>el.textContent=money(figureInline||active===2?cents*qty+(addon?2999:0):cents));
   document.querySelectorAll('[data-selected-format]').forEach(el=>el.textContent=variant?.dataset.title||variant?.textContent.trim()||'');
    document.querySelectorAll('[data-sticky-label]').forEach(el=>el.textContent=figureInline?(form.querySelector('[data-photo-input]')?.checkValidity()?'Buy now':'Add your photo'):active===2?'Buy now':started?'Continue customizing':'Start customizing');
   updatePreview();
  };
  if(figureInline){
   panels.forEach(panel=>panel.hidden=false);
   form.querySelectorAll('[data-wizard-controls]').forEach(el=>el.hidden=true);
   form.addEventListener('input',sync);form.addEventListener('change',sync);
   sticky?.querySelector('a')?.addEventListener('click',event=>{
    event.preventDefault();
    const photo=form.querySelector('[data-photo-input]');
    if(!photo?.checkValidity()){photo?.click();return;}
    form.requestSubmit(form.querySelector('[data-buy-now-button]'));
   });
   if(sticky){sticky.hidden=false;document.body.dataset.eluneMobilePurchase='true';}
   sync();return;
  }
  const show=(index,focus=true)=>{
   active=index;panels.forEach((panel,i)=>panel.hidden=i!==index);
   nav.forEach(button=>{if(Number(button.dataset.stepGo)===index)button.setAttribute('aria-current','step');else button.removeAttribute('aria-current');});
   sync();if(focus){const heading=panels[index].querySelector('[data-step-heading]');heading.focus({preventScroll:true});heading.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}
  };
  const validate=end=>{
   for(let i=0;i<=end;i++){const invalid=[...panels[i].querySelectorAll('input,select,textarea')].find(el=>el.willValidate&&!el.checkValidity());
    if(invalid){show(i);invalid.closest('details')?.setAttribute('open','');invalid.reportValidity();return false;}}
   return true;
  };
  form.querySelectorAll('[data-wizard-controls]').forEach(el=>el.hidden=false);
  nav.forEach(button=>button.addEventListener('click',()=>{const next=Number(button.dataset.stepGo);started=true;if(next<=active||validate(next-1))show(next);}));
  form.querySelectorAll('[data-step-next]').forEach(button=>button.addEventListener('click',()=>{started=true;if(validate(active))show(Math.min(2,active+1));}));
  form.addEventListener('submit',event=>{
   started=true;
   if(active<2){event.preventDefault();event.stopImmediatePropagation();if(validate(active))show(active+1);return;}
   if(!validate(2)){event.preventDefault();event.stopImmediatePropagation();}
  },true);
  form.addEventListener('input',()=>{started=true;sync();});form.addEventListener('change',()=>{started=true;sync();});
   sticky?.querySelector('a')?.addEventListener('click',event=>{event.preventDefault();started=true;if(active===2){form.requestSubmit(form.querySelector('[data-buy-now-button]'));return;}show(active);});
  if(sticky){sticky.hidden=false;document.body.dataset.eluneMobilePurchase='true';}
  show(0,false);
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
